import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import Popup from "@my-dld/components/Popup/Popup";
import { JQModal } from "@my-dld/components/Popup/Utils";

interface Props {
	message: string;
	OnDismiss: ( val: string ) => void;
}

interface State {
}

class AlertPopUp extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {};
	}

	render() {
		return <div className="modal-logout">
			<Popup
				id={ "alert-confirm" }
				showCloseButton={ true }
				clickOutsideToDismiss={ false }
				showIcon={ false }
				noTitle={ false }>
				<p className="logout-text">
					{ this.props.message }
				</p>
				<div>
					<button
                        className="btn btn_1 btn-block mb-2" type="button"
						onClick={ () => {
							this.dismissModel( "yes" );
						} }>{ Strings.yes }</button>
					<button
						className="btn btn-grey btn-block" type="button"
						onClick={ () => {
							this.dismissModel( "no" );
						} }>{ Strings.no }</button>
				</div>
			</Popup>
		</div>;
	}

	private dismissModel = ( val: string ) => {
		this.props.OnDismiss( val );
		JQModal( "alert-confirm" ).hide();
	};
}

export default AlertPopUp;
